// Core
import { Component } from '@angular/core';
import { environment } from '../../../../../environments/environment';

// Components
import { Navbar } from "./components/navbar/navbar";

@Component({
    selector: 'app-index-masterhead-section',
    imports: [Navbar],
    templateUrl: './index-masterhead-section.html',
    styleUrl: './index-masterhead-section.scss',
})
export class IndexMasterheadSection {
    environment = environment;
}
